import React, { useRef, useState, useEffect } from "react";
import { Grid } from "@mui/material";
import { Tabs, Tab, Box, Container, Card } from "@mui/material";
import { useInView } from "react-intersection-observer";
import checkicon from '../../assets/images/check-mark-icon-symbols-vector-600nw-1906113508.webp'
import crossicon from '../../assets/images/exclude.png'
import './../Package/NewPackageInfo.css';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import starPointer from '../../assets/images/rightarrow.png'

function NewPackageInfoDetails(props) {
    const [newPackageDetails, setNewPackageDetails] = useState([])
    const [activeTab, setActiveTab] = useState(0);
    const [expanded, setExpanded] = useState(null);
    const [manualTabChange, setManualTabChange] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : null);
    };

    const sectionRefs = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null),useRef(null)];

    // Lower threshold for better detection and rootMargin to adjust observation area
    const { ref: ref1, inView: inView1 } = useInView({ threshold: 0.2, rootMargin: '-150px 0px -50% 0px' });
    const { ref: ref2, inView: inView2 } = useInView({ threshold: 0.2, rootMargin: '-150px 0px -50% 0px' });
    const { ref: ref3, inView: inView3 } = useInView({ threshold: 0.2, rootMargin: '-150px 0px -50% 0px' });
    const { ref: ref4, inView: inView4 } = useInView({ threshold: 0.2, rootMargin: '-150px 0px -50% 0px' });
    const { ref: ref5, inView: inView5 } = useInView({ threshold: 0.2, rootMargin: '-150px 0px -50% 0px' });
    const { ref: ref6, inView: inView6 } = useInView({ threshold: 0.2, rootMargin: '-150px 0px -50% 0px' });

    useEffect(() => {
        if (props) {
            setNewPackageDetails(props.itineraryList);
        }
    }, [props]);

    // Only update active tab based on scroll if not manually changed
    useEffect(() => {
        if (!manualTabChange) {
            if (inView1) setActiveTab(0);
            else if (inView2) setActiveTab(1);
            else if (inView3) setActiveTab(2);
            else if (inView4) setActiveTab(3);
            else if (inView5) setActiveTab(4);
            else if (inView6) setActiveTab(5);
        }
    }, [inView1, inView2, inView3, inView4, inView5,inView6, manualTabChange]);

    // Reset manual tab change flag after scrolling
    useEffect(() => {
        let timeoutId;
        if (manualTabChange) {
            timeoutId = setTimeout(() => {
                setManualTabChange(false);
            }, 1000); // Wait for 1 second after scrolling
        }
        return () => clearTimeout(timeoutId);
    }, [manualTabChange]);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        setManualTabChange(true); // Set flag to indicate manual tab change

        // Calculate header height - adjust this value based on your actual header height
        const headerOffset = 130; // Approximate height of sticky header

        if (sectionRefs[newValue].current) {
            const elementPosition = sectionRefs[newValue].current.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    };

    return (
        <div>
            <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                    <Container>
                        <Box className='newPackageInfoDetails-tab' 
                        // sx={{
                        //     position: "sticky",
                        //     top: { sm: "122px", md: "122px" },
                        //     background: "#fffbdf",
                        //     color: '#2d2b29',
                        //     zIndex: 999,
                        //     marginBottom: 3,
                        // }}
                        >
                            <Tabs
                                className="tabs"
                                value={activeTab}
                                onChange={handleTabChange}
                                variant="scrollable"
                                scrollButtons="auto"
                                allowScrollButtonsMobile
                            >
                                <Tab label="Overview & Highlights" sx={{ textTransform: "none", fontWeight: 600, fontSize: '15px' }} />
                                <Tab label="Itinerary" sx={{ textTransform: "none", fontWeight: 600, fontSize: '15px' }} />
                                <Tab label="Inclusions" sx={{ textTransform: "none", fontWeight: 600, fontSize: '15px' }} />
                                <Tab label="Exclusions" sx={{ textTransform: "none", fontWeight: 600, fontSize: '15px' }} />
                                <Tab label="Other Info" sx={{ textTransform: "none", fontWeight: 600, fontSize: '15px' }} />
                                <Tab label="Cancellation Policy" sx={{ textTransform: "none", fontWeight: 600, fontSize: '15px' }} />
                            </Tabs>
                        </Box>
                        <Card className="tab-box" sx={{
                            display: "flex", flexDirection: 'column', padding: 2, marginBottom: 3, borderRadius: 3,
                            boxShadow: '0px 0px 5px rgba(128, 128, 128, 0.3)',

                            "@media (max-width: 700px)": {
                                padding: '20px'
                            }
                        }} ref={(el) => { ref1(el); sectionRefs[0].current = el; }}>
                            <div>
                                <div className="mb-3">
                                    <h6>Overview & Highlights</h6>
                                </div>
                                <div>
                                    <ul>
                                        {props?.data?.tripHighlights && props?.data?.tripHighlights.map((content, index) => (
                                            <li key={content.id || `highlight-${index}`}>
                                                <div className="trip-highlights">
                                                    <p className="tripHighlightsContent">{content.tripHighlightsContent}</p>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </Card>
                        <Card sx={{
                            display: "flex", flexDirection: 'column', padding: 2,
                            "@media (max-width: 700px)": {
                                padding: '20px'
                            }, marginBottom: 3, borderRadius: 3,
                            boxShadow: '0px 0px 5px rgba(128, 128, 128, 0.3)'


                        }} ref={(el) => { ref2(el); sectionRefs[1].current = el; }}>
                            <div>
                                <div>
                                    <h6 className="mb-3">Itinerary</h6>
                                </div>
                                <div>
                                    {props?.data?.itineraryList && props?.data?.itineraryList.map((item, index) => (
                                        <Accordion
                                            className="itineraryaccordion"
                                            key={index}
                                            expanded={expanded === index}
                                            onChange={handleChange(index)}
                                            sx={{
                                                marginBottom: 2, '&::before': {
                                                    backgroundColor: 'transparent!important',
                                                    boxShadow: 'none ',
                                                    borderRadius: 3,
                                                }
                                            }}
                                        >
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                                sx={{
                                                    backgroundColor: '#fffbdf',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    gap: 2,
                                                    borderRadius: 3,
                                                }}
                                            >
                                                <Typography
                                                    component="span"
                                                    sx={{
                                                        fontWeight: '700',
                                                        backgroundColor: '#fff099',
                                                        color: '#2d2b29',
                                                        borderRadius: '10px',
                                                        px: 2,
                                                        py: 1,
                                                        minWidth: '70px',
                                                        textAlign: 'center',
                                                        fontSize: { sm: '12px', md: '13px' },
                                                        fontWeight: 600,
                                                        display: 'flex',
                                                        flexShrink: 0,
                                                        marginRight: 2,
                                                        alignItems: 'center',
                                                        height: '40px',
                                                        justifyContent: 'center',

                                                    }}
                                                >
                                                    DAY {item.dayValue}
                                                </Typography>

                                                <Typography
                                                    component="span"
                                                    sx={{
                                                        fontSize: { sm: '12px', sm: '13px' },
                                                        fontWeight: 600,
                                                        flex: 1,
                                                        display: 'flex',
                                                        whiteSpace: 'normal',
                                                        wordBreak: 'break-word',
                                                        alignItems: 'center',

                                                    }}
                                                >
                                                    {item.itineraryName}
                                                </Typography>
                                            </AccordionSummary>

                                            <AccordionDetails className="accordion-details">
                                                <ul className="itineraryList list-disc pl-5 list-style: none; padding-left: 1.5em; text-indent: -1.5em;">
                                                    {item.itineraryInfoDetails?.map((item) => (
                                                        <li className="itineraryInfoList d-flex flex-row items-start " key={item.itineraryInfoId}>
                                                            <div className="col-1 star-pointer text-end">
                                                                <img className="right-arrow-icon" src={starPointer} alt="bullet" />
                                                            </div>
                                                            <div className="col-11 d-flex align-items-center ">
                                                                <span className="d-flex align-items-center">{item.description}</span>
                                                            </div>

                                                        </li>
                                                    ))}
                                                </ul>
                                            </AccordionDetails>
                                        </Accordion>

                                    ))}
                                </div>
                            </div>
                        </Card>
                        <Card sx={{
                            display: "flex", flexDirection: 'column', padding: 2,
                            "@media (max-width: 700px)": {
                                padding: '20px'
                            }, backgroundColor: '#F5FFF6', marginBottom: 3, borderRadius: 3, fontStyle: "'Poppins', 'Helvetica', sans-serif",
                            boxShadow: '0px 0px 5px rgba(128, 128, 128, 0.3)'

                        }} ref={(el) => { ref3(el); sectionRefs[2].current = el; }}>
                            <div>
                                <div>
                                    <h6 className="mb-3">Inclusions</h6>
                                </div>
                                <div>
                                    <ul className="inclusionlist">
                                        {props?.data?.inclusionsList && props?.data?.inclusionsList.map((item) => (
                                            <li key={item.inclusionsId}>
                                                <div className="trip-inclusion">
                                                    <img className="correct-icon" src={checkicon} alt="" />
                                                    <span className="inclusion-name">{item.inclusionsName}</span>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </Card>
                        <Card sx={{
                            backgroundColor: '#FFF4F4', display: "flex", alignItems: "center", padding: 2,
                            "@media (max-width: 700px)": {
                                padding: '20px'
                            }, marginBottom: 3, borderRadius: 3, fontStyle: "'Poppins', 'Helvetica', sans-serif",
                            boxShadow: '0px 0px 5px rgba(128, 128, 128, 0.3)'

                        }} ref={(el) => { ref4(el); sectionRefs[3].current = el; }}>
                            <div>
                                <div>
                                    <h6 className="mb-3">Exclusions</h6>
                                </div>
                                <div>
                                    <ul className="exclusionlist">
                                        {props?.data?.exclusionsList && props?.data?.exclusionsList.map((item, index) => (
                                            <li key={item.exclusionsId}>
                                                <div className="trip-inclusion">
                                                    <img className="cross-icon m-1" src={crossicon} alt="" />
                                                    <span className="exclusion-name">{item.exclusionsName}</span>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </Card>
                        <Card sx={{
                            display: "flex", alignItems: "center", padding: 2,
                            "@media (max-width: 700px)": {
                                padding: '20px'
                            }, marginBottom: 3, borderRadius: 3, fontStyle: "'Poppins', 'Helvetica', sans-serif",
                            boxShadow: '0px 0px 5px rgba(128, 128, 128, 0.3)'
                        }} ref={(el) => { ref5(el); sectionRefs[4].current = el; }}>
                            <div>
                                <div>
                                    <h6>Other Info</h6>
                                </div>
                                {props?.data?.otherInformation && props.data.otherInformation.map((item) => (
                                    <div key={item.otherInformationId}>
                                        <div className="font-semibold mb-2 infoTitle">
                                            {item.infoTitle}:
                                        </div>
                                        <ul className="otherdetails list-disc pl-5">
                                            {item.otherInfoDetails?.map((detail) => (
                                                <li className="mb-1 infopoints" key={detail.otherInfoDetailsId}>
                                                    {detail.infoPoints}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        </Card>
                        <Card sx={{
                            display: "flex", alignItems: "center", padding: 2,
                            "@media (max-width: 700px)": {
                                padding: '20px'
                            }, marginBottom: 3, borderRadius: 3, fontStyle: "'Poppins', 'Helvetica', sans-serif",
                            boxShadow: '0px 0px 5px rgba(128, 128, 128, 0.3)'
                        }} ref={(el) => { ref6(el); sectionRefs[5].current = el; }}>
                            <div>
                                <div>
                                    <h6>Cancellation Policy</h6>
                                </div>
                                <>
                                    <table class="cancellation-table">
                                        <thead>
                                            <tr>
                                                <th>
                                                    Cancellation received no. of days prior to departure
                                                </th>
                                                <th>
                                                    Cancellation fee applicable on Net Tour Price (per
                                                    person)
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Day - 0 to 5</td>
                                                <td>100%</td>
                                            </tr>
                                            <tr>
                                                <td>Day - 6 to 15</td>
                                                <td>85%</td>
                                            </tr>
                                            <tr>
                                                <td>Day - 16 to 30</td>
                                                <td>75%</td>
                                            </tr>
                                            <tr>
                                                <td>Day - 31 to 45</td>
                                                <td>50%</td>
                                            </tr>
                                            <tr>
                                                <td>Day - 46 to 60</td>
                                                <td>30%</td>
                                            </tr>
                                            <tr>
                                                <td>Day - 61 to 90</td>
                                                <td>20%</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </>
                            </div>
                        </Card>
                    </Container>
                </Grid>
            </Grid>
        </div>
    )
}

export default NewPackageInfoDetails